import { fetchAPI } from '.'

import {
  CommitRequest,
  CommitResponse,
  ListCostCentersResponse,
  ListOperationsResponse,
  ListRecentInvoicesResponse,
  PreviewRequest,
  PreviewResponse,
} from '@/api/generated'

export async function listBillingOps() {
  return fetchAPI<ListOperationsResponse>({
    method: 'GET',
    url: '/api/v1/internal/billing-ops/operations',
  })
}

export async function listCostCentersForEnterprise(enterpriseId: string) {
  return fetchAPI<ListCostCentersResponse>({
    method: 'GET',
    url: `/api/v1/internal/billing-ops/cost-centers/${enterpriseId}`,
  })
}

export async function listRecentInvoicesForCostCenter(costCenterId: string) {
  return fetchAPI<ListRecentInvoicesResponse>({
    method: 'GET',
    url: `/api/v1/internal/billing-ops/invoices/${costCenterId}`,
  })
}

export async function previewBillingOp(request: PreviewRequest) {
  return fetchAPI<PreviewResponse>({
    method: 'POST',
    url: '/api/v1/internal/billing-ops/preview',
    data: request,
  })
}

export async function commitBillingOp(request: CommitRequest) {
  return fetchAPI<CommitResponse>({
    method: 'POST',
    url: '/api/v1/internal/billing-ops/commit',
    data: request,
  })
}
